<template>
  <div v-if="enquiryReservationsData">
    <div
      v-for="(enquiry, index) in enquiryReservationsData"
      :key="index"
      class="container-collapse-with-btns"
    >
      <b-button
        v-b-toggle="`item${index}`"
        class="btn btn-lg btn-collapse collapse-data"
      >
        <div class="p-t-container">
          <div class="row collapse-title">
            {{
              `${$t("enquiryReservations.code")}: ${isDataExist(
                enquiry.enquiryReservationCode
              )} - ${isDataExist(enquiry.enquiryReservationNameCurrent)}`
            }}
          </div>
          <div class="collapse-icon">
            <span class="counter">{{ index + 1 }}</span>
            <i class="fa fa-angle-down" aria-hidden="true"></i>
          </div>
        </div>
      </b-button>
      <div class="collapse-actions btn-collapse">
        <!-- <div>
          <router-link
            :to="`/reservations/enquiry-reservation-details/${enquiry.enquiryReservationToken}`"
            :title="$t('info')"
          >
            <img src="@/assets/images/info.svg" class="icon-lg" />
          </router-link>
        </div> -->
        <div v-if="enquiry.reservationsStatus != true">
          <!-- <router-link
            :to="`/reservations/add-reservation/${enquiry.enquiryReservationToken}`"
            :title="$t('pages.ReservationAdd')"
          >
            <img src="@/assets/images/confirm.svg" class="icon-lg" />
          </router-link> -->
          <button
            v-b-modal.ReservationConfirm
            class="btn p-0"
            :title="$t('pages.ReservationAdd')"
            @click="setReservationData(enquiry)"
          >
            <img src="@/assets/images/confirm.svg" class="icon-lg" />
          </button>
        </div>
        <div>
          <button
            v-b-modal.EnquiryReservationDelete
            class="btn p-0"
            :title="$t('cancel')"
            @click="setEnquiryReservationData(enquiry)"
          >
            <img src="@/assets/images/cancel.svg" class="icon-lg" />
          </button>
        </div>
      </div>
      <b-collapse :id="`item${index}`">
        <!-- #region enquiry -->
        <div class="table-container">
          <table class="my-table">
            <thead>
              <tr>
                <th>{{ $t("enquiryReservations.code") }}</th>
                <th>{{ $t("clientName") }}</th>
                <th>{{ $t("activities.name") }}</th>
                <th>{{ $t("places.code") }}</th>
                <th>{{ $t("places.name") }}</th>
                <th>{{ $t("enquiryReservations.totalPrice") }}</th>
                <th>{{ $t("userMakeAction") }}</th>
                <th>{{ $t("actionDateTime") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ isDataExist(enquiry.enquiryReservationCode) }}</td>
                <td>{{ isDataExist(enquiry.clientNameCurrent) }}</td>
                <td>{{ isDataExist(enquiry.activityNameCurrent) }}</td>
                <td>{{ isDataExist(enquiry.placeCode) }}</td>
                <td>{{ isDataExist(enquiry.placeNameCurrent) }}</td>
                <td>{{ moneyFormat(enquiry.totalPrice) }}</td>
                <td>{{ isDataExist(enquiry.addedByUserNameCurrent) }}</td>
                <td>
                  {{
                    formateDateTimeLang(enquiry.actionDate, enquiry.actionTime)
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- #endregion enquiry -->

        <!-- #endregion enquirySchedules -->
        <div
          v-if="enquiry.enquiryReservationsSchedulesData"
          class="table-container"
        >
          <table class="my-table">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t("enquiryReservations.scheduleCode") }}</th>
                <th>{{ $t("day") }}</th>
                <th>{{ $t("enquiryReservations.fromDateTime") }}</th>
                <th>{{ $t("enquiryReservations.toDateTime") }}</th>
                <th>{{ $t("enquiryReservations.duration") }}</th>
                <th>{{ $t("enquiryReservations.totalPrice") }}</th>
                <th>{{ $t("notes") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(
                  item, indexSchedule
                ) in enquiry.enquiryReservationsSchedulesData"
                :key="indexSchedule"
              >
                <td>{{ ++indexSchedule }}</td>
                <td>{{ isDataExist(item.enquiryReservationScheduleCode) }}</td>
                <td>{{ isDataExist(item.dayNameCurrent) }}</td>
                <td>{{ formateDateTimeLang(item.dateFrom, item.timeFrom) }}</td>
                <td>{{ formateDateTimeLang(item.dateTo, item.timeTo) }}</td>
                <td>{{ isDataExist(item.actualDurationTime) }}</td>
                <td>{{ moneyFormat(item.appointmentPrice) }}</td>
                <td>{{ isDataExist(item.enquiryReservationScheduleNotes) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- #endregion enquirySchedules -->
      </b-collapse>
    </div>
  </div>
</template>

<script>
import {
  isDataExist,
  formateDateTimeLang,
  moneyFormat,
} from "@/utils/functions";

export default {
  name: "TransactionPointsTable",
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
    };
  },
  props: ["enquiryReservationsData", "enquiryReservationData"],
  methods: {
    setEnquiryReservationData(enquiryReservationData) {
      this.$emit("setEnquiryReservationData", enquiryReservationData);
    },
    setReservationData(enquiryReservationData) {
      this.$emit("setReservationData", enquiryReservationData);
    },
    isDataExist(data) {
      return isDataExist(data);
    },
    moneyFormat(data) {
      return moneyFormat(data);
    },
    formateDateTimeLang(date, time) {
      return formateDateTimeLang(date, time, this.language);
    },
  },
  computed: {},
  async created() {},
};
</script>

<style lang="scss"></style>
